export enum SystemGroups {
  IdeaRoom = 'IdeaRoom',
}
